import { createFileRoute } from '@tanstack/react-router';
import { AdminAssistantPage } from '@/features/admin/admin-assistant-page';
import { createProtectedGuard } from '@/lib/route-guards';

// Both ADMIN and OPERATIONS can access AI Assistant
const assistantGuard = createProtectedGuard({ roles: ['ADMIN', 'OPERATIONS'] });

export const Route = createFileRoute('/admin/assistant/')({
  beforeLoad: assistantGuard,
  component: AssistantIndexRoute,
});

function AssistantIndexRoute() {
  return <AdminAssistantPage />;
}
